import React from 'react';
import { Box } from '@mui/material';
import { useStyles } from './AppointmentEvaluationDctQuestion.styles';
import EvaluationSectionCollapse from '../../../provider/sessions/evaluations/evaluation-section-collapse';

const AppointmentEvaluationDctQuestion = ({
  evaluation,
  setSelectedSection,
  selectedSection,
  evaluationContext,
  allSectionsOpen,
}) => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.body}>
        {evaluation.sections?.map((section, idx) => {
          return (
            <EvaluationSectionCollapse
              key={idx}
              index={idx}
              section={section}
              evaluationCompleted
              selectedSection={selectedSection}
              onSelectSection={setSelectedSection}
              evaluation={evaluation}
              setMultiSelect={false}
              onSelectMultiSelect={item => {
                console.log(item);
              }}
              skippedCBTs={[]}
              alfieValidation
              evaluationContext={evaluationContext}
              externallyCollapsed={allSectionsOpen}
            />
          );
        })}
      </Box>
    </>
  );
};

export { AppointmentEvaluationDctQuestion };
